import { CustomException, request } from '@tencent/ppd-base-libs';
import { defaultParams, QRY_DP_MSG, requestConfigs } from '../config';
import { QryDpMsgReq, QryDpMsgRes } from '../types/index';
import { formatDpItem, handleFormatObj, TargetType } from '../utils/format';
import { isPassPreCheck } from '../utils/pre-check-params';
import { getCgiName, reportElk } from '../utils/report';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const needParseIntKey = ['appid', 'dp_channel'];
const targetUrl = QRY_DP_MSG;


/** 接口1 - 查询投放信息 */
export const queryDpMessageByPosId = async (qryParams:
Omit<QryDpMsgReq, 'appid' | 'dpChannel'>) => {
  const params = {
    ...defaultParams,
    ...qryParams,
  };
  const needCheckFields = ['appid', 'dpChannel', 'dpPage', 'uin'];
  if (!isPassPreCheck(params, needCheckFields)) {
    new CustomException(params, 'dpLoader-ParamsError', `${getCgiName(targetUrl)}接口参数缺失`);
    return;
  }
  let formattedParams = {};
  let returnResult = {};
  try {
    formattedParams = handleFormatObj({
      targetType: TargetType.line,
      target: params, needParseIntKey,
    });
    const result = await request.post(targetUrl, formattedParams, requestConfigs);
    returnResult = handleFormatObj({
      targetType: TargetType.hump,
      target: result, transformer: (res) => {
        if (!res) {
          return res;
        }
        const dpList = res.dpList || [];
        return {
          ...res,
          dpList: dpList.map(item => formatDpItem(item)),
        };
      },
    });
    // 返回的投放计划可能会超长，因此进行response的压缩再上报
    reportElk({ url: targetUrl, params: formattedParams, res: compressRes(returnResult) });
  } catch (e) {
    reportElk({ url: targetUrl, params: formattedParams, res: e as any });
    throw e;
  }
  console.log('====queryDpMessageByPosId result', returnResult);
  return returnResult as QryDpMsgRes;
};

/**
 * 压缩待上报的res信息。
 * 返回的dpList字段内容太多了会导致超长，需要精简
 */
const compressRes = (res) => {
  const dpList = res?.dpList;
  if (dpList) {
    return {
      ...res,
      dpList: dpList.map(item => ({
        dpPosition: item.dpPosition,
        dpId: item.dpId,
        componentId: item.componentId,
        componentVer: getComponentVersion(item.componentUrl),
      })),
    };
  }
  return res;
};

/** 从组件url中提取组件版本号 */
const getComponentVersion = (componentUrl: string) => {
  const reg = new RegExp(/\d+(\.\d+){2}/);
  const result = reg.exec(componentUrl);
  return result?.[0] || componentUrl;
};
